const faqs = [
  {
    q: '桃花视频是否需要注册才能观看？',
    a: '不需要。桃花视频所有内容完全免费，无需注册登录即可直接在线观看91视频、久久视频等全部资源，没有任何观看限制。',
  },
  {
    q: '为什么有些视频播放时会缓冲？',
    a: '桃花视频采用智能CDN加速技术，绝大多数影片都能实现流畅不缓冲的播放体验。如果偶尔遇到缓冲，建议检查当前网络环境或切换播放线路，系统会自动适配最优码率。',
  },
  {
    q: '平台上的91在线视频资源多久更新一次？',
    a: '我们保持每日更新频率，每天新增200+部影视内容。热门电视剧在播出后24小时内上线，电影资源最快48小时内更新高清版本，确保观众第一时间看到最新内容。',
  },
  {
    q: '桃花视频支持哪些设备观看？',
    a: '全面支持电脑端、平板和手机浏览器访问，同时兼容主流投屏协议。无论你在家用大屏还是外出用手机，都能享受一致的高清观影体验。',
  },
];

export function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-600 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

const topics = [
  { tag: '悬疑烧脑', heat: '9.8w', rank: 1 },
  { tag: '古装仙侠', heat: '9.2w', rank: 2 },
  { tag: '韩剧精选', heat: '8.6w', rank: 3 },
  { tag: '国漫崛起', heat: '8.1w', rank: 4 },
  { tag: '动作大片', heat: '7.5w', rank: 5 },
  { tag: '都市爱情', heat: '6.9w', rank: 6 },
  { tag: '科幻巨制', heat: '6.3w', rank: 7 },
  { tag: '恐怖惊悚', heat: '5.8w', rank: 8 },
  { tag: '历史战争', heat: '5.2w', rank: 9 },
  { tag: '甜宠短剧', heat: '4.7w', rank: 10 },
  { tag: '旅行综艺', heat: '4.1w', rank: 11 },
];

export function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          本周热搜
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#cards"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-accent-300/60 hover:bg-accent-50/50 transition-all cursor-pointer group"
              >
                <span className={`w-5 h-5 flex items-center justify-center rounded-full text-xs font-bold ${
                  topic.rank <= 3 ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {topic.rank}
                </span>
                <span className="text-sm text-foreground-800 group-hover:text-accent-700 whitespace-nowrap">{topic.tag}</span>
                <span className="text-xs text-foreground-600">{topic.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

const mediaItems = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20movie%20trailer%20thumbnail%20style%20image%20with%20dramatic%20action%20scene%2C%20explosion%20and%20motion%20blur%2C%20warm%20golden%20and%20coral%20color%20grading%2C%20cinematic%20aesthetic%2C%20professional%20film%20promotional%20style%2C%20clean%20composition%2C%20editorial%20quality%2C%20high%20contrast&width=640&height=360&seq=media-01&orientation=landscape",
    title: '《逆光追凶》终极预告',
    duration: '02:35',
    views: '128.6万',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20romantic%20drama%20film%20trailer%20thumbnail%20with%20two%20characters%20in%20emotional%20moment%2C%20soft%20warm%20lighting%2C%20cinematic%20depth%20of%20field%2C%20professional%20film%20promotional%20aesthetic%2C%20clean%20composition%2C%20editorial%20quality&width=640&height=360&seq=media-02&orientation=landscape",
    title: '《星河万里》大结局抢先看',
    duration: '03:12',
    views: '96.3万',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20science%20fiction%20animated%20film%20trailer%20thumbnail%20with%20futuristic%20city%20and%20spaceships%2C%20vibrant%20warm%20colors%2C%20epic%20scale%2C%20professional%20animation%20promotional%20style%2C%20clean%20composition%2C%20editorial%20quality&width=640&height=360&seq=media-03&orientation=landscape",
    title: '《星域纪元》新季PV公开',
    duration: '01:48',
    views: '85.7万',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20Korean%20thriller%20drama%20trailer%20thumbnail%20with%20mysterious%20atmosphere%20and%20tense%20expressions%2C%20cold%20and%20warm%20color%20contrast%2C%20cinematic%20suspense%20mood%2C%20professional%20film%20promotional%20style%2C%20clean%20composition%2C%20editorial%20quality&width=640&height=360&seq=media-04&orientation=landscape",
    title: '《迷雾追踪》花絮特辑',
    duration: '05:20',
    views: '72.1万',
  },
];

export function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          精彩预告
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-200/60 transition-all hover:-translate-y-1"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs bg-black/70 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 leading-snug mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              手机观影，随时随地看好片
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-md">
              桃花视频移动端完美适配手机浏览器，无需下载APP即可享受全部功能。高清画质、流畅播放、智能续播，让你在通勤、午休、旅途中也能轻松追剧。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-android-line text-lg"></i>
                Android 访问
              </div>
              <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line text-lg"></i>
                iOS 访问
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-[240px] h-[480px] rounded-2xl overflow-hidden border-4 border-foreground-900/20 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20mobile%20phone%20screen%20mockup%20displaying%20a%20video%20streaming%20app%20interface%20with%20movie%20posters%20grid%2C%20warm%20coral%20and%20amber%20accent%20colors%2C%20clean%20UI%20design%2C%20minimalist%20layout%2C%20professional%20app%20screenshot%20style%2C%20high%20detail&width=480&height=960&seq=app-mockup-01&orientation=portrait"
                alt="桃花视频手机端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const rankingData = [
  { rank: 1, title: '逆光追凶', type: '电影', heat: '本周播放 1,286万', change: 'up' as const, tag: 'NEW' },
  { rank: 2, title: '星河万里', type: '电视剧', heat: '本周播放 1,098万', change: 'up' as const },
  { rank: 3, title: '星域纪元', type: '动漫', heat: '本周播放 965万', change: 'same' as const },
  { rank: 4, title: '迷雾追踪', type: '韩剧', heat: '本周播放 887万', change: 'up' as const, tag: 'HOT' },
  { rank: 5, title: '说走就走 S3', type: '综艺', heat: '本周播放 754万', change: 'down' as const },
];

export function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热播排行榜</h2>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1 border border-background-200/60">
            <span className="px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer">本周</span>
            <span className="px-4 py-1.5 rounded-full text-xs text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer">本月</span>
            <span className="px-4 py-1.5 rounded-full text-xs text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer">总榜</span>
          </div>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer border-b border-background-200/60 last:border-b-0"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-300 text-accent-900' :
                item.rank === 3 ? 'bg-accent-200 text-accent-800' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{item.title}</span>
                  {item.tag && (
                    <span className={`px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap ${
                      item.tag === 'NEW' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-600">{item.type}</span>
                  <span className="text-xs text-foreground-600">·</span>
                  <span className="text-xs text-foreground-600">{item.heat}</span>
                </div>
              </div>

              <span className="flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-lg"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-500 text-lg"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-500 text-lg"></i>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}